import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import { MapPin } from 'lucide-react';

// Corrige le chemin des icônes de marqueurs Leaflet avec webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const formatAddress = (c) => {
  const parts = [];
  if (c.adresse) parts.push(c.adresse);
  const cpVille = [c.code_postal, c.ville].filter(Boolean).join(' ');
  if (cpVille) parts.push(cpVille);
  return parts.join(', ');
};

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    const t = setTimeout(() => {
      map.invalidateSize();
      if (points.length > 0) {
        map.fitBounds(L.latLngBounds(points), { padding: [40, 40], maxZoom: 15 });
      }
    }, 200);
    return () => clearTimeout(t);
  }, [points, map]);
  return null;
}

export const ClientsMap = ({ clients, height = '500px' }) => {
  const navigate = useNavigate();
  const geocoded = (clients || []).filter(
    (c) => c.latitude !== null && c.latitude !== undefined && c.longitude !== null && c.longitude !== undefined
  );
  const points = geocoded.map((c) => [c.latitude, c.longitude]);

  if (geocoded.length === 0) {
    return (
      <div
        style={{ height }}
        className="rounded-xl border border-border/60 bg-muted/20 flex flex-col items-center justify-center text-center p-6"
        data-testid="map-empty"
      >
        <MapPin className="w-12 h-12 text-muted-foreground mb-3" strokeWidth={1} />
        <p className="text-muted-foreground">Aucune adresse géolocalisée à afficher</p>
      </div>
    );
  }

  return (
    <div style={{ height }} className="rounded-xl overflow-hidden border border-border/60" data-testid="clients-map">
      <MapContainer
        center={points[0]}
        zoom={12}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FitBounds points={points} />
        {geocoded.map((c) => (
          <Marker key={c.id} position={[c.latitude, c.longitude]}>
            <Popup>
              <div className="space-y-1">
                <div className="font-semibold">{c.prenom} {c.nom}</div>
                {c.telephone && <div>{c.telephone}</div>}
                {formatAddress(c) && <div className="text-muted-foreground">{formatAddress(c)}</div>}
                <button
                  type="button"
                  onClick={() => navigate(`/clients?client=${c.id}`)}
                  className="mt-1 text-primary font-medium underline underline-offset-2 hover:opacity-80 cursor-pointer bg-transparent border-0 p-0"
                  data-testid={`map-view-client-${c.id}`}
                >
                  Voir la fiche →
                </button>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default ClientsMap;
